import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisclaimerModalModule } from './disclaimer-modal';
import { PollingModule } from './polling';

@NgModule({
  imports: [CommonModule, DisclaimerModalModule, PollingModule],
})
export class ExtractModule {}
